export function RowDivider() {
  return <div className="h-px bg-separators-non-opaque col-span-full" />;
}
